// extracted by mini-css-extract-plugin
module.exports = {"button":"LargeToggleButton_button__u_N02","buttonActive":"LargeToggleButton_buttonActive__AbiPz"};